export default "/_next/static/assets/images/lotto/replay-logo.724e2015f7e2d39e9b39ba031f8d104c.png";